import { IdentityProviders, SignInPage } from "@backstage/core-components";
import {
    configApiRef,
    oktaAuthApiRef,
    useApi,
} from "@backstage/frontend-plugin-api";
import { SignInPageProps } from "@backstage/plugin-app-react";

/**
 * Custom Backstage sign-in page component.
 *
 * Renders the Okta auth provider by default. When `auth.providers.guest` is
 * present in app-config, an additional guest sign-in option is shown (for
 * development environments only).
 *
 * Displays a warning banner in environments whose URL contains "dev".
 */
export const AuthSignInPage = (props: SignInPageProps) => {
    const configApi = useApi(configApiRef);
    const guestProviders: IdentityProviders =
        configApi.getOptional("auth.providers.guest") !== undefined
            ? ["guest"]
            : [];

    const oktaAuth = {
        id: "okta-auth-provider",
        title: "OKTA",
        message: "Sign in using your OKTA credentials.",
        apiRef: oktaAuthApiRef,
    };

    const isDev = window.location.href.includes("dev");

    return (
        <SignInPage
            {...props}
            auto
            align="center"
            title={
                isDev
                    ? "Warning: This environment is for development only."
                    : ""
            }
            providers={[oktaAuth, ...guestProviders]}
        />
    );
};
